// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__Go+9c","paginationMark":"Pagination_paginationMark__n3hAs"};